import React from 'react';
import '../css/SlideTransition.css';
import { Link } from 'react-router-dom';

export function Footer() { // (Arrow Function Declaration)
    return (
        <div className="backer contact-wrap" style={{ padding: '2rem', textAlign: 'center' }}>
            <h2 >
                ⚓ Dirty Yachtin' Scoundrels
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#ccc', maxWidth: '600px', margin: '0 auto' }}>
                Wanna get the party started? 🎉 Drop us a line and let's make it happen —
                <br />
                <Link to="/contact" style={{ color: '#00bfff', fontWeight: 'bold', textDecoration: 'underline' }}>
                    Contact Us
                </Link>
            </p>
        </div>
    );
}